import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ExameService } from "src/app/shared/services/exame.service";
import { exameActions } from "./exame.actions";
import { catchError, concatMap, exhaustMap, map, of, tap } from "rxjs";
import { NotifyService } from "src/app/shared/services/notify.service";

@Injectable()

export class ExameEffects {

    constructor(
        private service: ExameService,
        private notify: NotifyService,
        private action$: Actions
    ) { }


    loadExame$ = createEffect(() =>
        this.action$.pipe(
            ofType(exameActions.loadExame),
            exhaustMap(() =>
                this.service
                    .get()
                    .pipe(
                        map((res: any) => exameActions.loadExameSuccess({ lista: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(exameActions.loadExameError())
                        })
                    )
            )
        )
    )

    loadExamByID$ = createEffect(() =>
        this.action$.pipe(
            ofType(exameActions.loadExameByID),
            concatMap(
                ({ id }) =>
                    this.service
                        .getByID(id)
                        .pipe(
                            map((res) => exameActions.loadExameByIDSuccess({ exam: res })),
                            catchError((error) => {
                                this.notify.emitError('Falha ao carregar registros')
                                return of(error.error['hydra:description'])
                            })
                        )
            )
        )
    )

    editExame$ = createEffect(() =>
        this.action$.pipe(
            ofType(exameActions.editExame),
            concatMap(
                ({ exame, id }) =>
                    this.service
                        .edit(exame, id)
                        .pipe(
                            tap(() => this.notify.editSuccess()),
                            map(() => exameActions.editExameSuccess()),
                            catchError((error) => {
                                this.notify.emitError(error.error['hydra:description']);
                                return of(exameActions.editExameError());
                            })
                        )
            )
        )
    );

    saveExame$ = createEffect(() =>

        this.action$.pipe(
            ofType(exameActions.saveExame),
            concatMap(
                ({ exame }) =>
                    this.service
                        .post(exame)
                        .pipe(
                            tap(() => this.notify.saveSuccess()),
                            map(() => exameActions.saveExameSuccess()),
                            catchError(
                                (error) => {
                                    this.notify.emitError(error.error['hydra:description']);
                                    return of(exameActions.saveExameError())
                                }
                            )

                        )
            )
        )

    )

    deleteExame$ = createEffect(() =>
        this.action$.pipe(
            ofType(exameActions.deleteExame),
            concatMap(
                ({ id }) =>
                    this.service
                        .delete(id)
                        .pipe(
                            tap(() => this.notify.deleteSuccess()),
                            map(() => exameActions.loadExame()),
                            catchError((error) => {
                                this.notify.emitError(error.error['hydra:description']);
                                return of(error.error['hydra:description']);
                            }
                            )
                        )
            )

        )
    )

}